import type { PublishedEventListItem, TopMarketTypeDisplay } from '../../../../@types';
import { usePublishedFeaturedEventCardModel } from '../../../../hooks/useFeaturedEventCardModel';
import EventCardBase from './EventCardBase';

type EventCardProps = {
  event: PublishedEventListItem;
  topMarketTypes?: TopMarketTypeDisplay[];
};

const EventCard = ({ event, topMarketTypes }: EventCardProps) => {
  const model = usePublishedFeaturedEventCardModel(event, topMarketTypes);

  return <EventCardBase model={model} />;
};

export default EventCard;
